import { createStore, combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';

 
import { MSalState, rootReducerMSAL } from './msalRedux';
import { menuReducer, MenuState } from './reducers/menuReducer';
import { prefReducer, PrefState } from './reducers/prefReducer';
import { userReducer, UserState } from './reducers/userReducer';
import { messagesReducer, MessagesState } from './reducers/messagesReducer';
import { webPresenceReducer, WebPresence } from './reducers/userReducer';
import storageSession from 'redux-persist/lib/storage/session'
//export const Store = createStore(menuReducer);

export const rootReducer = combineReducers({
    menu: menuReducer,
    user: userReducer,
    msgs: messagesReducer,
    msalstate: rootReducerMSAL,
    pref: prefReducer,
    webPresenceReducer: webPresenceReducer
})

const persistConfig = {
    key: 'root', 
    storage: storageSession,
}

const persistedReducer = persistReducer(persistConfig, rootReducer)
const Store = createStore(
    persistedReducer,
    (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION__()
);

const persistor = persistStore(Store)

export { Store, persistor }

export interface RootState {
    menu: MenuState,
    user: UserState,
    msgs: MessagesState,
    msalstate: MSalState,
    pref: PrefState,
    webPresenceReducer: WebPresence
}
